// 负责处理与收入相关的api
import ApiBase from './api_base'

export default class IncomeApi {
  static index() {
    return ApiBase.get('/projects/income')
  }

  static show(id) {
    return ApiBase.get(`/projects/${id}/income`)
  }
}



// WEBPACK FOOTER //
// ./src/api/income.js